import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-x-icon',
  standalone: true,
  templateUrl: './file-x-icon.component.html'
})
export class FileXIconComponent {
  @Input() size: number | string = 18;
  @Input() color: string = 'currentColor';
}
